import NavBar from "../../../components/NavBar/NavBar";
import { noticias } from "../../../constants/Institucional/noticias";
import { Banner, BannerText, BannerLogo } from "../../../styles/Banner";
import { Link as RouterLink } from "react-router-dom";
import { Box, Typography, Link } from "@mui/material";
import { Card, CardContent, CardMedia, Button, } from "@mui/material";
import Footer from "../../../components/Footer/Footer";
import NavLinkItem from "../QuemSomos/NavLinksItem";

const Imprensa = () => {
    return (
        <>
            <NavBar/>
            <Banner>
                <BannerText>
                    <p>
                        <a href="https://www.meucupom.com/" target='_blank' rel="noreferrer">Home</a> &gt; Institucional &gt; Imprensa
                    </p>
                    <Box>
                        <Typography variant='h2' sx={{
                        fontSize: { xs: '1.2rem', sm: '2rem', md: '2rem', fontWeight: 'bold', textAlign: 'center'}
                    }}>Imprensa</Typography>
                    </Box>
                
                    <Box>
                        <NavLinkItem to="/institucional/quem-somos" label="Quem somos?" />
                        <NavLinkItem to="/institucional/imprensa" label="Imprensa" />
                        <NavLinkItem to="/institucional/contato" label="Contato" />
                    </Box>
                </BannerText>
                <BannerLogo>
                    <img 
                        src="https://cdn.meucupom.com/app-assets/5.07.56/novomc/assets/images/logo-negative.png" 
                        alt="MeuCupom Logo" 
                    />
                </BannerLogo>
            </Banner>
            <Box sx={{ padding: { xs: 2, sm: 4 }, maxWidth: 1300, margin: "0 auto" }}>
                <Typography variant="h5" sx={{ mb: 5, fontWeight: 'bold', textAlign: 'center', textTransform: 'uppercase', color: 'var(--c-brand-accent-bright)' }}>
                    Meu Cupom na Mídia
                </Typography>
                {noticias.map((item, index) => (
                <Card key={index} sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    mb: 3,
                    borderRadius: 3,
                    overflow: 'hidden',
                    boxShadow: 3,
                    transition: 'transform 0.3s, box-shadow 0.3s',
                    '&:hover': {
                    transform: 'translateY(-3px)',
                    boxShadow: 5,
                    }
                }}>
                    <CardMedia
                    component="img"
                    image={item.imagem}
                    alt={item.titulo}
                    sx={{ width: { xs: '100%', sm: 250 }, height: 200, objectFit: 'contain', p:  { xs: 0, sm: 2, md: 2 } }}
                    />
                    <CardContent sx={{ flex: 1, p: 2 }}>
                        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                            {item.data}
                        </Typography>
                        <Typography variant="h6" component="div" gutterBottom sx={{ fontWeight: 'bold' }}>
                            "{item.titulo}"
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            {item.resumo}
                        </Typography>
                        <Button variant="contained" size="small" href={item.link}
                        target="_blank" 
                        rel="noopener noreferrer"
                        >Ler mais</Button>
                    </CardContent>
                </Card>
                ))}
            </Box>
            <Footer/>
        </>
    )
}
export default Imprensa;